var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExploitsAndKev = function SvgExploitsAndKev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#exploits-and-kev_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M5.714 19.34c0-2.872 0-4.308.438-5.576a8 8 0 0 1 1.847-2.989c.938-.958 2.223-1.6 4.791-2.884l1.486-.743c2.099-1.05 3.148-1.574 4.249-1.78a8 8 0 0 1 2.95 0c1.101.206 2.15.73 4.25 1.78l1.485.743c2.569 1.284 3.853 1.926 4.791 2.884a8 8 0 0 1 1.848 2.99c.437 1.267.437 2.703.437 5.574v1.322c0 2.871 0 4.307-.437 5.575A8 8 0 0 1 32 29.225c-.938.958-2.222 1.6-4.79 2.884l-1.487.743c-2.099 1.05-3.148 1.574-4.249 1.78a8 8 0 0 1-2.95 0c-1.1-.206-2.15-.73-4.25-1.78l-1.485-.743c-2.568-1.284-3.853-1.926-4.791-2.884a8 8 0 0 1-1.847-2.99c-.438-1.267-.438-2.703-.438-5.574z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M20 13.334V20m0 6.667h.017"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "exploits-and-kev_svg__a",
    x1: 31.751,
    x2: -26.645,
    y1: 5.153,
    y2: 25.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgExploitsAndKev;